import { AxiosResponse } from "axios";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Tooltip,
  Whisper
} from "rsuite";
import { EPDatePicker, EPInput } from "../../../common/controls";
import { Info } from "../../../common/controls/info";
import {
  PostProject,
  UpdateProject
} from "../../../common/utils/api";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import { axiosPost, axiosUpdate } from "../../../common/utils/helper";
import Loader from "../../Loader/loader";

interface IProject {
  ProjectId?: number;
  CompanyName?: string;
  ClientName?: string;
  ProjectName?: string;
  ProjectStartDate?: Date;
  ProjectEndDate?: Date;
  CreatedBy?: number;
}
interface Props {
  open: boolean;
  action?: string;
  isValidate?: boolean;
  refresher?: boolean;
  setRefresher?: any;
  singleData?: any;
  setOpen: (open: boolean) => void;
}

export default function AddProjectModal(props: Props) {
  const { open, setOpen, action, setRefresher, singleData, refresher } = props;
  // const [ProjectName, setProjectName] = useState<string>(
  //   singleData?.ProjectName ? singleData?.ProjectName : ""
  // );

  const [projectModalData, setProjectModalData] = useState<any>({
    ProjectId: singleData?.ProjectId,
    CompanyName: singleData?.CompanyName,
    ClientName: singleData?.ClientName,
    ProjectName: singleData?.ProjectName,
    ProjectStartDate: singleData?.ProjectStartDate,
    ProjectEndDate: singleData?.ProjectEndDate,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [UpdateDisable, setUpdateDisable] = useState<boolean>(true);
  const [isValidate, setIsValidate] = useState(false);
  const regexPattern =
    /^(?!\d+$)(?!.*\s{2})(?!.*\.{2})(?!.*\.\s)[a-zA-Z0-9\s.]+$/;

  let response: AxiosResponse;
  function closeModal() {
    setOpen(false);
  }
  function handleKeyPress(event: any) {
    if (
      (event?.target?.value?.endsWith(" ") &&
        !regexPattern.test(event?.target?.value + event?.key)) ||
      !regexPattern.test(event?.target?.value + event?.key)
    ) {
      event.preventDefault();
    }
  }

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  }

  // const handleClose = () => {
  //   setLeadModal(false);
  // };

  const handleOnChange = (value: string | number | Date, name: string) => {
    let data = { ...projectModalData };
    data[name] = value;
    setProjectModalData(data);
  };

  async function handleSubmit() {
    setIsValidate(true);
    if (
      !projectModalData?.ProjectName ||
      !projectModalData?.CompanyName ||
      !projectModalData?.ClientName ||
      !projectModalData?.ProjectStartDate ||
      !projectModalData?.ProjectEndDate
    ) {
      const message = "Field cannot be empty.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      projectModalData?.ProjectName?.trim().length < 3 ||
      projectModalData?.CompanyName?.trim().length < 3 ||
      projectModalData?.ClientName?.trim().length < 3
    ) {
      const message = "Please fill mandatory fields.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } 
    else {
      action === "Add"
        ? await postProjectName(PostProject, {
            ProjectName: projectModalData?.ProjectName?.trim(),
            CompanyName: projectModalData?.CompanyName?.trim(),
            ClientName: projectModalData?.ClientName?.trim(),
            ProjectStartDate: projectModalData?.ProjectStartDate,
            ProjectEndDate: projectModalData?.ProjectEndDate,
          })
        : await updateProjectName(
            `${UpdateProject}/${projectModalData?.ProjectId}`,
            {
              ProjectName: projectModalData?.ProjectName?.trim(),
              CompanyName: projectModalData?.CompanyName?.trim(),
              ClientName: projectModalData?.ClientName?.trim(),
              ProjectStartDate: projectModalData?.ProjectStartDate,
              ProjectEndDate: projectModalData?.ProjectEndDate,
            }
          );
      refresher ? setRefresher(false) : setRefresher(true);
      closeModal();
    }
  }

  async function postProjectName(reqUrl: string, reqBody: IProject) {
    setLoading(true);
    response = (await axiosPost(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      setLoading(false);
      toast.success("Project saved successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      setLoading(false);
      toast.warning("Project already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  async function updateProjectName(reqUrl: string, reqBody: IProject) {
    response = (await axiosUpdate(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      toast.success("Project updated successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      toast.warning("Project already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  return loading ? (
    <Loader />
  ) : (
    <Modal open={open} onClose={closeModal} className="modal-sm" backdrop="static" keyboard={false} onKeyDown={handleModalKeyDown}>
      <Modal.Header closeButton={true}>
        {action === "Edit" ? "Edit Project" : "Add Project"}
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs lg="12" className="recruiter-label">
            Project Name <span className="req">* </span>
            <Info message="Minimum 3 characters, Maximum 30 characters" />
          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPInput
                  onKeyPress={handleKeyPress}
                  label="Project"
                  minlength={3}
                  maxlength={30}
                  style={{ width: 100 }}
                  onChange={(val: string) => handleOnChange(val, "ProjectName")}
                  value={projectModalData?.ProjectName}
                  isValidate={isValidate}
                />
              </Whisper>
            </Col>

          <Col xs lg="12" className="recruiter-label">
            Company Name <span className="req">* </span>
            <Info message="Minimum 3 characters, Maximum 30 characters" />
          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPInput
                  onKeyPress={handleKeyPress}
                  label="Project"
                  minlength={3}
                  maxlength={30}
                  style={{ width: 100 }}
                  onChange={(val: string) => handleOnChange(val, "CompanyName")}
                  value={projectModalData?.CompanyName}
                  isValidate={isValidate}
                />
              </Whisper>
            </Col>

          <Col xs lg="12" className="recruiter-label">
            Client Name <span className="req">* </span>
            <Info message="Minimum 3 characters, Maximum 30 characters" />

          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPInput
                  onKeyPress={handleKeyPress}
                  label="Project"
                  minlength={3}
                  maxlength={30}
                  style={{ width: 100 }}
                  onChange={(val: string) => handleOnChange(val, "ClientName")}
                  value={projectModalData?.ClientName}
                  isValidate={isValidate}
                />
              </Whisper>
            </Col>

          <Col xs lg="12" className="recruiter-label">
            Project Start Date <span className="req">*</span>
          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPDatePicker
                  disabled={false}
                  isValidate={isValidate}
                  onChange={(date: Date) => handleOnChange(date, "ProjectStartDate")}
                  value={projectModalData?.ProjectStartDate}
                  disableDateCriteria="disableDatesAfterEndDate"
                  endDate={projectModalData?.ProjectEndDate}
                />
              </Whisper>
            </Col>

          <Col xs lg="12" className="recruiter-label">
            Project End Date <span className="req">*</span>
          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPDatePicker
                  disabled={false}
                  isValidate={isValidate}
                  onChange={(date: Date) => handleOnChange(date, "ProjectEndDate")}
                  value={projectModalData?.ProjectEndDate}
                  disableDateCriteria="disableDatesBeforeStartDate"
                  startDate={projectModalData?.ProjectStartDate}
                />
              </Whisper>
            </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="pt-3">
        <Row>
          <Col xs lg>
            <Button
              type="button"
              onClick={() => handleSubmit()}
              className="btn btn-primary"
            >
              {action === "Edit" ? "Update" : "Save"}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
